import { max } from 'lodash';

import { GrossRevenueGraphData } from '../../../../../../interfaces/entity-dashboard/GrossRevenueData';
import { getLabelForPeriod } from '../../../../../../../shared/features/charts';

type GraphInfo = {
  labels: string[];
  currentValues: number[];
  previousValues: number[];
};

export type GrossRevenueGraphInfo = GraphInfo & {
  maxValue: number | undefined;
};

const ceilToNiceNumber = (value: number): number => {
  if (value <= 0) {
    return 0;
  }

  const magnitude = Math.pow(10, Math.floor(Math.log10(value)));
  const step = magnitude >= 1000 ? magnitude : 1000;

  return Math.ceil(value / step) * step;
};

export const getGraphInfo = (
  grossRevenueGraphData: GrossRevenueGraphData,
): GrossRevenueGraphInfo => {
  const { groupBy, data } = grossRevenueGraphData;

  const graphInfo = data.reduce<GraphInfo>(
    (acc, point) => {
      const label = getLabelForPeriod(
        point.currentPeriodRevenue.periodFrom,
        point.currentPeriodRevenue.periodTo,
        groupBy,
      );

      acc.labels.push(label);
      acc.currentValues.push(point.currentPeriodRevenue.value);
      acc.previousValues.push(point.previousPeriodRevenue.value);

      return acc;
    },
    { labels: [], currentValues: [], previousValues: [] },
  );

  const allValues = [...graphInfo.currentValues, ...graphInfo.previousValues];
  const rawMax = max(allValues);
  const maxValue = rawMax ? ceilToNiceNumber(rawMax) : undefined;

  return { ...graphInfo, maxValue };
};
